import React from 'react';
import { useTranslation } from 'react-i18next';
import BottomSheetSelector from '../../../../../app/dashboard/BottomSheetSelector';
import { IHotelData } from '../../../../../app/@types/bottomSheet';

interface IHotelSelectorPortalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  sortedHotels: IHotelData[];
  selectedHotel: string;
  setSelectedHotel: (hotelId: string) => void;
  selectedClient: string;
  setSelectedClient: (clientId: string) => void;
  selectedBrand: string;
  setSelectedBrand: (brandId: string) => void;
}

function HotelSelectorPortal ({
  isOpen,
  setIsOpen,
  sortedHotels,
  selectedHotel,
  setSelectedHotel,
  selectedClient,
  setSelectedClient,
  selectedBrand,
  setSelectedBrand,
}: IHotelSelectorPortalProps) {
  const { t } = useTranslation();

  if (!selectedHotel || !sortedHotels.length) {
    return null;
  }

  return (
    <BottomSheetSelector
      hotels={sortedHotels}
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      selectedHotel={selectedHotel}
      setSelectedHotel={setSelectedHotel}
      selectedClient={selectedClient}
      setSelectedClient={setSelectedClient}
      selectedBrand={selectedBrand}
      setSelectedBrand={setSelectedBrand}
      isSearchable={true}
      title={t('COMMON.DASHBOARD.FIELDS.CHOOSE_HOTEL')}
      searchableInputPlaceHolder={t('COMMON.DASHBOARD.FIELDS.BRAND_OR_HOTEL')}
    />
  );
}

export { HotelSelectorPortal };
